import React from 'react';
import { Breadcrumb } from 'antd';
import { Helmet } from 'react-helmet';
import { useMediaQuery } from 'react-responsive';
import './Control.css';
import Footer from '../../Footer';
import { useTranslation } from 'react-i18next';

const ControlCND = () => {
   const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
   const { t, i18n } = useTranslation();

   return (
      <div>
         <Helmet>
            <title>{t('Contrôle CND des Structures et Ouvrages - Professional Inspectors')}</title>
            <meta
               name="description"
               content={t("Découvrez nos services de contrôle CND (Contrôle Non Destructif) pour les structures et les ouvrages. Contrôle par ressuage, ultrasons, magnétoscopie, visuel, mesure d’épaisseur, boîte à vide, doublures, endoscopie, revêtement/peinture.")}
            />
            <meta
               name="keywords"
               content={t("Contrôle CND, Contrôle Non Destructif, ressuage, ultrasons, magnétoscopie, visuel, mesure d’épaisseur, boîte à vide, doublures, endoscopie, revêtement, peinture, structures, ouvrages, Professional Inspectors")}
            />
         </Helmet>

         <div className="wrapper_CTL_z">
            <div className="container_15">
               <Breadcrumb separator=">">
                  <Breadcrumb.Item href="/">{t('Accueil')}</Breadcrumb.Item>
                  <Breadcrumb.Item>{t('Contrôle CND')}</Breadcrumb.Item>
               </Breadcrumb>
               <div className="row">
                  <div className="pic service_cover">
                     <img src="images/CND_A.jpg" className="img-fluid intro_image" />
                  </div>
                  <div className="col-sm-6 strategic">
                     <h3>{t('Contrôle Non Destructif (CND)')}</h3>
                     <p>
                           <li>{t('Contrôle par ressuage (PT)')}</li>
                           <li>{t('Contrôle par ultrasons (UT)')}</li>
                           <li>{t('Contrôle par magnétoscopie (MT)')}</li>
                           <li>{t('Contrôle visuel (VT)')}</li>
                           <li>{t('Contrôle mesure d’épaisseur')}</li>
                           <li>{t('Contrôle par boîte à vide')}</li>
                           <li>{t('Contrôle des doublures')}</li>
                           <li>{t('Contrôle par endoscopie')}</li>
                           <li>{t('Contrôle revêtement/peinture')}</li>
                     </p>
                  </div>
               </div>
            </div>
            <section className="solutions-area" id="services">
               <div className="container">
                  <div className="section-title">
                     <span className="sub-title">{t('Autres Activités')}</span>
                     <h2>{t('Domaine d\'Application')} :</h2>
                     <p>{t('La société « PROFESSIONAL INSPECTORS » assure le contrôle et l’inspection dans les domaines suivants :')}</p>
                  </div>
               </div>
               <main className="page-content-C">
                  <div className="card RSC">
                     <div className="content">
                        <h2 className="title">{t('Réception et Suivi de Construction (RSC)')}</h2>
                        <p className="copy"></p>
                        <a href="/controlRSC">
                           <button className="btn">{t('Détails')}</button>
                        </a>
                     </div>
                  </div>
                  <div className="card CRS">
                     <div className="content">
                        <h2 className="title">{t('Contrôle Réglementaire de Sécurité (CRS)')}</h2>
                        <p className="copy"></p>
                        <a href="/controlCRS">
                           <button className="btn">{t('Détails')}</button>
                        </a>
                     </div>
                  </div>
               </main>
            </section>
            <Footer />
         </div>
      </div>
   );
};

export default ControlCND;
